module.exports = __webpack_public_path__ + "img/DECHubTermsOfServiceZH.e8128c24.jpg";